import { render, staticRenderFns } from "./scenario.vue?vue&type=template&id=5de53483"
import script from "./scenario.vue?vue&type=script&lang=js"
export * from "./scenario.vue?vue&type=script&lang=js"
import style0 from "./scenario.vue?vue&type=style&index=0&id=5de53483&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports